// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExcelOutlinedSvg from "@fishx/icons-svg/es/asn/ExcelOutlined";
import FishxIcon from '../components/FishxIcon';

var ExcelOutlined = function ExcelOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExcelOutlinedSvg
  }));
};

ExcelOutlined.displayName = 'ExcelOutlined';
export default React.forwardRef(ExcelOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExcelOutlined.js
// module id = 2621
// module chunks = 0